// src/layout/Menu.jsx
import React, { useState } from "react";
import { Link, useLocation, Outlet } from "react-router-dom";

import {
  FiChevronRight,
  FiChevronDown,
  FiPlus,
  FiBox,
  FiPhone,
  FiUsers,
  FiClipboard,
  FiSettings,
  FiHome,
  FiBarChart2,
  FiAlertTriangle,
  FiLogOut,
  FiGlobe
} from "react-icons/fi";

export default function MenuLayout() {
  const location = useLocation();
  const [openAgregar, setOpenAgregar] = useState(false);
  const [openReportes, setOpenReportes] = useState(false);

  const isHome = location.pathname === "/";

  return (
    <div style={{ display: "flex", height: "100vh" }}>

      {/* SIDEBAR */}
      <aside
        style={{
          width: "240px",
          background: "#232f3e",
          color: "#f2f2f2",
          paddingTop: "14px",
          display: "flex",
          flexDirection: "column",
          borderRight: "1px solid #1b2733",
        }}
      >
        {/* TÍTULO */}
        <div style={{ padding: "0 20px", marginBottom: 20 }}>
          <h2 style={{ fontSize: "18px", fontWeight: "700", color: "#fff" }}>
            SISTEMA DE <br /> INVENTARIO
          </h2>
        </div>

        <AwsItem icon={<FiHome size={17} />} to="/" text="Inicio"
          active={location.pathname === "/"}
        />

        <AwsItem icon={<FiBarChart2 size={17} />} to="/dashboard" text="Dashboard"
          active={location.pathname.startsWith("/dashboard")}
        />

        {/* AGREGAR */}
        <div>
          <div
            onClick={() => setOpenAgregar(!openAgregar)}
            style={{
              padding: "10px 20px",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              background: openAgregar ? "#1f2a36" : "transparent",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
              <FiPlus size={17} /> Agregar
            </div>
            {openAgregar ? <FiChevronDown /> : <FiChevronRight />}
          </div>

          {openAgregar && (
            <div style={{ background: "#1f2a36", paddingLeft: 55 }}>
              <AwsSubItem to="/agregar" text="Crear Equipo" />
              <AwsSubItem to="/contratos/agregar" text="Crear Contrato" />
              <AwsSubItem to="/sitios/nuevo" text="Crear Credencial" />
            </div>
          )}
        </div>

        <AwsItem icon={<FiClipboard size={17} />} to="/inventario" text="Inventario"
          active={location.pathname.startsWith("/inventario")}
        />

        <AwsItem icon={<FiAlertTriangle size={17} />} to="/reemplazos" text="Reemplazos"
          active={location.pathname.startsWith("/reemplazos")}
        />

        <AwsItem icon={<FiPhone size={17} />} to="/contratos" text="Contratos"
          active={location.pathname.startsWith("/contratos")}
        />

        <AwsItem icon={<FiGlobe size={17} />} to="/sitios" text="Sitios"
          active={location.pathname.startsWith("/sitios")}
        />

        {/* REPORTES */}
        <div>
          <div
            onClick={() => setOpenReportes(!openReportes)}
            style={{
              padding: "10px 20px",
              cursor: "pointer",
              display: "flex",
              justifyContent: "space-between",
              background: openReportes ? "#1f2a36" : "transparent",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
              <FiBox size={17} /> Reportes
            </div>
            {openReportes ? <FiChevronDown /> : <FiChevronRight />}
          </div>

          {openReportes && (
            <div style={{ background: "#1f2a36", paddingLeft: 55 }}>
              <AwsSubItem to="/reportes/comparativo" text="Comparativo Anual" />
            </div>
          )}
        </div>

        <AwsItem icon={<FiSettings size={17} />} to="/configuracion" text="Configuración"
          active={location.pathname.startsWith("/configuracion")}
        />

        {/* LOGOUT */}
        <div style={{ marginTop: "auto", padding: 20 }}>
          <button
            onClick={() => (window.location.href = "/logout")}
            style={{
              width: "100%",
              padding: "10px",
              background: "#dc2626",
              color: "white",
              border: "none",
              borderRadius: "6px",
              cursor: "pointer",
              fontWeight: "600",
            }}
          >
            <FiLogOut /> Cerrar sesión
          </button>
        </div>
      </aside>

      {/* CONTENIDO */}
      <main
        style={{
          flex: 1,
          height: "100vh",
          overflowY: isHome ? "hidden" : "auto",
          background: "#f8fafc",
          padding: isHome ? 0 : 30,
        }}
      >
        <Outlet />
      </main>
    </div>
  );
}

/* =========================
   COMPONENTES AUXILIARES
========================= */

function AwsItem({ icon, text, to, active }) {
  return (
    <Link
      to={to}
      style={{
        padding: "10px 20px",
        display: "flex",
        gap: 12,
        textDecoration: "none",
        color: active ? "#fff" : "#d1d5db",
        background: active ? "#1f2a36" : "transparent",
        borderLeft: active ? "3px solid #00a1ff" : "3px solid transparent",
      }}
    >
      {icon}
      {text}
    </Link>
  );
}

function AwsSubItem({ to, text }) {
  return (
    <Link
      to={to}
      style={{
        display: "block",
        padding: "7px 0",
        fontSize: "14px",
        textDecoration: "none",
        color: "#cbd5e1",
      }}
    >
      {text}
    </Link>
  );
}
